module.exports = __webpack_public_path__ + "static/media/thumb-1920-587508.001ddf96.jpg";